import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const PILLARS = [
    {
        eyebrow: "Si el cuello de botella es velocidad",
        body: "Automatizamos cualificación, agenda y seguimiento. Tus leads buenos dejan de enfriarse mientras estás haciendo tu trabajo.",
    },
    {
        eyebrow: "Si el cuello de botella es volumen",
        body: "Sumamos prospección activa y voz proactiva. No esperas a que entren leads: construyes pipeline cada semana.",
    },
    {
        eyebrow: "Si el cuello de botella es el chasis",
        body: "Rediseñamos web, CRM, automatización y presencia editorial. Reconstruimos la maquinaria comercial entera con acompañamiento mensual del fundador durante todo el primer año.",
    },
];

export default function Partnerships() {
    return (
        <section
            id="sistema"
            data-testid="partnerships-section"
            className="bg-white py-28 md:py-40"
        >
            <div className="max-w-[1200px] mx-auto px-6 md:px-12">
                <div className="max-w-[860px]">
                    <p className="overline">El sistema</p>
                    <h2
                        data-testid="partnerships-headline"
                        className="font-serif-display mt-6 text-4xl md:text-6xl tracking-tight text-[#1A1A1A] leading-[1.05]"
                    >
                        Un mapa, no un menú.
                    </h2>
                    <p className="mt-5 font-serif-display italic text-lg md:text-2xl text-[#666666]">
                        No te pedimos que elijas. Después de conocerte a ti y a tu negocio, te decimos qué solución encaja.
                    </p>

                    <div className="mt-10 space-y-6 text-base md:text-lg text-[#1A1A1A] leading-[1.75] max-w-[760px]">
                        <p>
                            Operamos como un <strong>sistema estratégico de ventas que funciona sin
                            ti</strong>. No vendemos un paquete. Diagnosticamos dónde está el cuello
                            de botella real y construimos exactamente la pieza que tu negocio
                            necesita — ni más, ni menos.
                        </p>
                        <p>
                            La conversación de descubrimiento te ubica en el mapa. A partir de ahí,
                            la propuesta es a medida.
                        </p>
                    </div>
                </div>

                <div className="mt-16 md:mt-20 grid grid-cols-1 md:grid-cols-3 gap-px bg-[#E5E0D5] border border-[#E5E0D5]">
                    {PILLARS.map((p, i) => (
                        <div
                            key={i}
                            data-testid={`pillar-${i}`}
                            className="bg-white p-8 md:p-10"
                        >
                            <p className="font-serif-display text-5xl md:text-6xl text-[#8B6914] leading-none">
                                {String(i + 1).padStart(2, "0")}.
                            </p>
                            <p className="mt-6 text-xs tracking-[0.24em] uppercase text-[#1A1A1A]">
                                {p.eyebrow}
                            </p>
                            <p className="mt-4 text-[15px] md:text-base text-[#666666] leading-[1.75]">
                                {p.body}
                            </p>
                        </div>
                    ))}
                </div>

                <div className="mt-20 flex flex-col items-center text-center">
                    <span className="block h-px w-12 bg-[#8B6914]" aria-hidden="true" />
                    <p className="mt-6 font-serif-display italic text-xl md:text-2xl text-[#1A1A1A] max-w-[680px]">
                        No te pedimos que elijas. Te pedimos que hablemos.
                    </p>
                    <Link
                        to="/contacto"
                        data-testid="partnerships-cta"
                        className="mt-8 inline-flex items-center justify-center gap-3 px-8 py-4 bg-[#1A1A1A] text-white text-sm tracking-wide hover:bg-[#8B6914] transition-colors duration-200"
                    >
                        Reserva tu llamada de descubrimiento
                        <ArrowRight size={16} />
                    </Link>
                </div>
            </div>
        </section>
    );
}
